
import { defineComponent, PropType } from "vue";
import { Handle } from "@braks/vue-flow";
import FlowNodeWrapper from "@/components/bot/FlowNodeWrapper.vue";
import { IBlock } from "@chatcaptain/types/chatbot";

export interface IFlowConditionProps extends IBlock {
  showHandle: boolean;
}

export default defineComponent({
  name: "FlowNodeSplit",
  components: {
    FlowNodeWrapper,
    Handle,
  },
  props: {
    data: {
      type: Object as PropType<IFlowConditionProps>,
      required: true,
      default: () => {
        return {};
      },
    },
  },
});
